<a (click)="navigateWithObject(case)">Se målejournaler</a>